export default {
  data() {
    return {
      selected: [],
      item: {
        docs: [],
        page: null,
        pages: null,
      },
      infiniteId: 1,
      paginate: {
        page: 1,
        limit: 25,
      },
    }
  },
  methods: {
    reset() {
      this.selected = []
      this.paginate.page = 1
      this.item.docs = []
      this.item.page = null
      this.item.pages = null
      this.infiniteId++
    },
    next($state) {
      const id = this.infiniteId

      this.fetch().then(payload => {
        // id has been reset
        if (id !== this.infiniteId) {
          return
        }

        if (!payload || !payload.pages) return $state.complete()

        this.paginate.page++
        let { docs, ...rest } = payload

        if (docs) {
          if (payload.page > this.item.page) this.item.docs.push(...docs)
          if (payload.page < this.item.page) this.item.docs.unshift(...docs)
        }

        Object.entries(rest).forEach(([key, value]) => {
          this.item[key] = value
        })

        $state.loaded()
        if (this.isLast) $state.complete()
      })
    },
  },
}
